/* Styled at Suttles: look slideshows, photo zoom and the homepage looks row */
(function () {
  /* Photo zoom (lookbook page only): click a look photo to see it large, scroll to see the rest. Arrow buttons or arrow keys step through that look's photos; Esc, the X or a click on the photo closes it. */
  var zoom, zoomImg, zoomPrev, zoomNext, zoomList = [], zoomIndex = 0;

  function bestSrc(img) {
    var best = img.currentSrc || img.src;
    var bestW = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      var w = parseInt(bits[1], 10) || 0;
      if (bits[0] && w > bestW) { bestW = w; best = bits[0]; }
    });
    return best;
  }

  function showZoom(i) {
    zoomIndex = (i + zoomList.length) % zoomList.length;
    var img = zoomList[zoomIndex];
    zoomImg.src = bestSrc(img);
    zoomImg.alt = img.alt || '';
    zoom.scrollTop = 0;
    var many = zoomList.length > 1;
    zoomPrev.hidden = !many;
    zoomNext.hidden = !many;
  }

  function buildZoom() {
    if (zoom) return;
    zoom = document.createElement('dialog');
    zoom.className = 'sl-zoom';
    zoom.setAttribute('aria-label', 'Photo');
    zoom.innerHTML =
      '<img class="sl-zoom__img" alt="">' +
      '<button type="button" class="sl-zoom__btn sl-zoom__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="sl-zoom__btn sl-zoom__prev" aria-label="Previous photo">&lsaquo;</button>' +
      '<button type="button" class="sl-zoom__btn sl-zoom__next" aria-label="Next photo">&rsaquo;</button>';
    document.body.appendChild(zoom);
    zoomImg = zoom.querySelector('.sl-zoom__img');
    zoomPrev = zoom.querySelector('.sl-zoom__prev');
    zoomNext = zoom.querySelector('.sl-zoom__next');
    zoom.querySelector('.sl-zoom__close').addEventListener('click', function () { zoom.close(); });
    zoomPrev.addEventListener('click', function (e) { e.stopPropagation(); showZoom(zoomIndex - 1); });
    zoomNext.addEventListener('click', function (e) { e.stopPropagation(); showZoom(zoomIndex + 1); });
    zoom.addEventListener('click', function (e) {
      if (e.target === zoom || e.target === zoomImg) zoom.close();
    });
    zoom.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') showZoom(zoomIndex - 1);
      if (e.key === 'ArrowRight') showZoom(zoomIndex + 1);
    });
    zoom.addEventListener('close', function () { document.documentElement.classList.remove('sl-zoom-open'); });
  }

  function openZoom(root, img) {
    if (typeof HTMLDialogElement === 'undefined') return;
    buildZoom();
    zoomList = Array.prototype.slice.call(root.querySelectorAll('.sl-media__slide img'));
    document.documentElement.classList.add('sl-zoom-open');
    zoom.showModal();
    showZoom(Math.max(0, zoomList.indexOf(img)));
  }

  function initMedia(root) {
    if (root.dataset.slReady) return;
    root.dataset.slReady = '1';
    var track = root.querySelector('[data-sl-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sl-dot]'));
    var visible = false;
    var timer;

    function current() {
      return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function update() {
      var c = current();
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === c ? 'true' : 'false');
      });
      slides.forEach(function (s, i) {
        var v = s.querySelector('video');
        if (!v) return;
        if (i === c && visible) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }

    var prev = root.querySelector('[data-sl-prev]');
    var next = root.querySelector('[data-sl-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); });
    });
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(update, 80);
    }, { passive: true });

    if (root.closest('.sl-look')) {
      track.addEventListener('click', function (e) {
        var img = e.target.closest('.sl-media__slide img');
        if (img) openZoom(root, img);
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible = e.isIntersecting;
          update();
        });
      }, { threshold: 0.4 }).observe(root);
    } else {
      visible = true;
    }
    update();
  }

  function initRow(row) {
    if (row.dataset.slReady) return;
    row.dataset.slReady = '1';
    var track = row.querySelector('[data-sl-row-track]');
    var prev = row.querySelector('[data-sl-row-prev]');
    var next = row.querySelector('[data-sl-row-next]');
    if (!track) return;

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      row.classList.toggle('sl-row--scrollable', max > 4);
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
    }
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-sl-media]').forEach(initMedia);
    document.querySelectorAll('[data-sl-row]').forEach(initRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
